<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-app-bar dark color="#00a7d3">
          <v-toolbar-title>{{loading ? 'Loading...' : 'Info for Run id: ' + runId}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              icon
              @click="show=false"
              class="ml-auto"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
        <v-container>
          <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
            <v-col cols="9" md="11">
              <h3>{{'Delivery for the Stop ID: ' + this.runId}}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Search..." v-model="deliverySearch" prepend-icon="search"></v-text-field>
            </v-col>
          </v-row>
          <v-card class="mx-auto">
            <v-data-table
              :headers="headerDeliveries"
              :loading="loading"
              :search="deliverySearch"
              :items="renderedDeliveries"
            ></v-data-table>
          </v-card>
        </v-container>

        <v-divider style="background-color: lightskyblue"></v-divider>
        <v-container >
          <v-row>
            <v-col cols="9" md="11">
              <h3>{{'Tags for the Stop ID: ' + this.runId}}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Search..." v-model="tagsSearch" prepend-icon="search"></v-text-field>
            </v-col>
          </v-row>
          <v-card class="mx-auto">
            <v-data-table
              :headers="headerTags"
              :search="tagsSearch"
              :loading="loading"
              :items="renderedRunTags"
            ></v-data-table>
          </v-card>
        </v-container>

      </v-card>
    </v-dialog>

    <v-dialog v-model="addStopDialog" width="350px">
      <v-card>
        <v-card-title>
          Add a stop
        </v-card-title>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field
                v-model="stop.tracking"
                label="Tracking"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="stop.version"
                label="version of stop"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="indigo" @click="saveStop">Add stop</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this stop. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "RunsStopsDialog",
  components: {

  },
  props: {
    runId: Number,
    showDialog: Boolean,
    runObj: Object,
  },
  data (){
    return {
      reload: false,
      reloadTags: false,
      loading: false,
      loadingTags: false,
      loadingPallets: false,
      reloadPallets: false,
      selectedRun: null,
      selectedRunId: null,
      headerTags: [
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Transaction', value: 'transaction', align: 'center', sortable: true},
        {text: 'Type', value: 'type', align: 'center', sortable: true},
        {text: 'Item', value: 'item', align: 'center', sortable: true},
        {text: 'Description', value: 'description', align: 'center', sortable: true},
        {text: 'Number', value: 'number', align: 'center', sortable: true},
        {text: 'Quantity', value: 'quantity', align: 'center', sortable: true},
        {text: 'Production Date', value: 'production_date', align: 'center', sortable: true},
      ],
      headerDeliveries: [
        {text: 'Client Name', value: 'client_name', align: 'center', sortable: true},
        {text: 'Zone Name', value: 'zone_name', align: 'center', sortable: true},
        {text: 'Street', value: 'street1', align: 'center', sortable: true},
        {text: 'Suburb', value: 'suburb', align: 'center', sortable: true},
        {text: 'State', value: 'state', align: 'center', sortable: true},
        {text: 'Postcode', value: 'postcode', align: 'center', sortable: true},
        {text: 'Time Window Start', value: 'time_window_start', align: 'center', sortable: true},
        {text: 'Time Window End', value: 'time_window_end', align: 'center', sortable: true},
        {text: 'Date', value: 'date', align: 'center', sortable: true}
      ],
      addStopDialog:false,
      stop:{
        run_id:'',
        tracking:null,
        version:null,
      },
      deleteDialog:false,
      toBeDeleted:null,
      tagsSearch:'',
      deliverySearch:'',


    }
  },
  methods: {
    selectRow(item){
      this.selectedRun = item;
      this.selectedRunId = item.id;
    },
    removeStop(item){
      this.toBeDeleted =Object.assign({}, item);
      this.deleteDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    toggleDelete(){
      alert(this.toBeDeleted.tracking);

      let body = {
        tracking:this.toBeDeleted.tracking,
      };
      axios.post(process.env.API_URL + '/runs/' + this.runId + '/removestop', body)
        .then((response) => {
          this.toBeDeleted = null;
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Delete successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
        });
      this.deleteDialog = false;
    },
    saveStop(){
      let body = {
        tracking:this.stop.tracking,
        version:this.stop.version,
      };
      axios.post(process.env.API_URL + '/runs/' + this.runId + '/stops', body)
        .then((response) => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Update successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
        });

      this.addStopDialog = false;

    },
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        if (!value) this.$emit('close');
      }
    },
    renderedRunTags() {
      if (this.runTags === null || this.runTags === undefined){
        return [];
      } else {
        return this.runTags;
      }
    },
    renderedDeliveries() {
      if (this.deliveries === null || this.deliveries === undefined){
        return [];
      } else {
        return this.deliveries;
      }
    }
  },
  asyncComputed: {
    async runTags() {
      if (this.reload || !this.reload){
        if (this.runId) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/runs/' + this.runId + '/tags')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async deliveries() {
      if (this.reload || !this.reload){
        if (this.runId) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/runs/' + this.runId + '/deliveries')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Runs/RunsDialog.vue